'use client'
import cl from 'clsx'
import Button from '@/ui/button'
import Link from 'next/link';
import { scrollTo } from '@/utils/scrollTo'
import styles from './styles.module.css'

export default function HeroVideo({dict}) {
    return (
        <section className={styles.hero__video_wrapper}>
            <div className="container">
                <div className={styles.hero__button_container}>
                    <div className={cl(styles.hero__button_wrapper,)}>
                        <Link  href={'#'} onClick={(event) => scrollTo(event, "offer", -220)}>
                        <Button 
                            type='round-bottom' 
                            externalText={dict.hero_video.title}
                            section='hero-video'
                        />
                        </Link>
                    </div>
                </div>
            </div>

            <div className={styles.hero__button_mobile_wrapper}>
                <Link  href={'#'} onClick={(event) => scrollTo(event, "offer", 20)}>
                    <Button type='round-bottom-mobile' />
                </Link>
            </div>

            <div className={styles.hero__video_overlay}></div>

            <video className={styles.hero_video} width="320" height="240" controls={false} preload="none" autoPlay loop muted playsInline>
                <source src="/video/hero.mp4" type="video/mp4" />
                Your browser does not support the video tag.
            </video>
        </section>
    )
}
